import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../app/redux/hooks";
import { getReferralCodeAsync } from "../../../../../app/slices/profileSlice/ProfileSlice";
import { CircularProgress } from "@mui/material";

export const ReferAndEarn = () => {
  const dispatch = useAppDispatch();

  const [whatsappLink, setWhatsappLink] = useState("");
  const [code, setCode] = useState("");
  const [copied, setCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getReferralCodeAsync()).then((response: any) => {
      if (response?.payload?.data?.status === 1) {
        const referralCode = response.payload.data.referral_code;
        setCode(referralCode);
      } else {
        setCode("");
      }
      setIsLoading(false);
    });
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleWhatsAppButton = () => {
    const message = `Use my referral code *${code}* and get 10% off your first order from Navya Bakers! 🍰🎉`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
    setWhatsappLink(whatsappUrl);
  };

  return (
    <div className="my-account-content account-order">
      <h4 className="title-right">Refer &amp; Earn</h4>
      {isLoading ? (
        <div className="wrap-account-order">
          <div
            className="wrap-account-order"
            style={{
              minHeight: "50vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </div>
        </div>
      ) : (
        <div className="wrap-account-order">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-6">
              <img src="images/refer-earn.png" className="img-fluid" alt="" />
            </div>
            <div className="col-md-6">
              <div className="row align-items-center">
                <div className="col-2">
                  <img src="images/star.svg" width="30" alt="" />
                </div>
                <div className="col-10">
                  Refer a friend and both of you will get a 10% discount on your
                  first purchase!
                </div>
              </div>
              <div className="row align-items-center mt-3">
                <div className="col-2">
                  <img src="images/star.svg" width="30" alt="" />
                </div>
                <div className="col-10">
                  Share your referral code and start earning sweet rewards!
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-center mt-4 flex-wrap gap-3">
            <a
              onClick={handleWhatsAppButton}
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="tf-btn animate-hover-btn me-3 radius-3 justify-content-center orange-b btn-add-note"
              style={{
                pointerEvents: code ? "auto" : "none",
                opacity: code ? 1 : 0.6,
              }}
            >
              <img src="images/whatsapp.svg" alt="" />
              <span className="ms-2">Invite via WhatsApp</span>
            </a>

            <div
              className="tf-btn btn-fill animate-hover-btn me-3 radius-3 justify-content-center"
              style={{ cursor: "default" }}
            >
              {code ? (
                <span>
                  Referral code: <strong>{code}</strong>
                </span>
              ) : (
                <span>Referral code not available</span>
              )}
            </div>

            <div style={{ position: "relative" }}>
              <a
                onClick={handleCopy}
                className="tf-btn btn-fill animate-hover-btn radius-3 justify-content-center btn-add-note"
                style={{
                  pointerEvents: code ? "auto" : "none",
                  opacity: code ? 1 : 0.6,
                }}
              >
                <img src="images/copy.svg" alt="" />
                <span className="ms-2">Copy Referral Code</span>
              </a>
              {copied && (
                <div
                  style={{
                    position: "absolute",
                    top: "-28px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#000",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    zIndex: 2,
                  }}
                >
                  Copied!
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
